import translations from '../locales'

export function getTourSteps(lang: string) {
  const translation = translations[lang as keyof typeof translations]
  return [
    {
      attachTo: { element: '#tourFirstAnchor' },
      content: {
        title: translation.views.tour.steps[0].title,
        text: translation.views.tour.steps[0].text
      }
    },
    {
      attachTo: { element: '#initialExtent' },
      content: {
        title: translation.views.tour.steps[1].title,
        text: translation.views.tour.steps[1].text
      }
    },
    {
      attachTo: { element: '#search' },
      content: { title: translation.views.tour.steps[2].title, text: translation.views.tour.steps[2].text }
    },
    {
      attachTo: { element: '#ZMenuItem-applayers' },
      content: {
        title: translation.views.tour.steps[3].title,
        text: translation.views.tour.steps[3].text
      }
    },
    {
      attachTo: { element: '#ZMenuItem-appincidents' },
      content: {
        title: translation.views.tour.steps[4].title,
        text: translation.views.tour.steps[4].text
      }
    },
    {
      attachTo: { element: '#ZMenuItem-appprint' },
      content: {
        title: translation.views.tour.steps[5].title,
        text: translation.views.tour.steps[5].text
      }
    },
    {
      attachTo: { element: '#tourFirstAnchor' },
      content: {
        title: translation.views.tour.steps[6].title,
        text: translation.views.tour.steps[6].text
      }
    }
  ]
}
